export default __webpack_public_path__ + "static/media/certificates-profile-act.9235b44d.svg";